import React, { useEffect, useState } from 'react';

//Material
import { Grid, Paper, Typography } from '@mui/material';
// import { Stack } from '@mui/system';
import { connect } from 'react-redux';
import Illustration1 from '../../assets/Banners/illustration0.png';
import Illustration2 from '../../assets/Banners/illustration1.png';
import Illustration3 from '../../assets/Banners/illustration2.png';
import Illustration4 from '../../assets/Banners/illustration3.png';
import Illustration5 from '../../assets/Banners/illustration4.png';

import '../../pages/MainPage/index.css';
import { LetsGoBtn } from '../Buttons';
import { useNavigate } from 'react-router-dom';
// import  ImageGallery  from 'react-image-gallery';

// const useStyles = makeStyles({

//   button: {
//     '&:hover': {
//       boxShadow: '-5px 5px 3px black !important',
// width: '155px !important'
//   },
// }})
function Banner1() {
  const navigate = useNavigate();
  const [randomBg, setRandombg] = useState(0);
  const [randomPos, setRandomPos] = useState(0);
  const bg = [Illustration1, Illustration2, Illustration3, Illustration4, Illustration5];

  useEffect(() => {
    const randomBg = Math.floor(Math.random() * bg.length);

    setRandombg(randomBg);
    if (randomBg >= 3) {
      setRandomPos(1);
    } else {
      setRandomPos(0);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Paper
      // {...props}
      // key={}
      // className="serviceCard"
      sx={{
        width: '100%',
        maxWidth: '809px',
        margin: '0px',
        textAlign: 'center',
        overflow: 'hidden',
        alignItems: 'center',
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        borderRadius: '16px',
        padding: '16px ',
        border: '2px solid #E2F2FF !important',
        backgroundColor: 'white',
        backgroundImage: `url(${bg[randomBg]})`,
        position: 'relative',
        backgroundSize: randomPos === 0 ? 'contain' : 'cover',
        height: { xs: 'unset', sm: '212px' }
      }}
    >
      <Grid
        container
        spacing={0}
        sx={{
          width: { xs: randomPos === 0 ? '100%' : '61%', sm: randomPos === 0 ? '100%' : '55%' },
          margin: '0px !important',
          height: '100%',
          backgroundColor: randomPos === 0 ? '#FFFFFFF2' : '#FFFFFFA6',
          p: '8px',
          borderRadius: '8px'
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'start',
            flexDirection: 'column',
            alignItems: randomPos === 0 ? 'center' : 'start'
          }}
        >
          <Typography
            variant="p"
            sx={{
              margin: '0px',
              wordBreak: 'break-word',
              fontFamily: 'FixelText-Medium !important',
              fontWeight: 500,
              fontSize: { xs: randomPos === 0 ? '24px' : '14px', sm: '24px' },
              textAlign: randomPos === 0 ? 'center' : 'left',
              mt: randomPos === 0 ? 2 : 0
            }}
          >
            Відкрийте нові можливості з
            <Typography
              variant="p"
              sx={{
                fontFamily: 'FixelText-Medium !important',
                fontWeight: 500,
                fontSize: { xs: randomPos === 0 ? '24px' : '14px', sm: '24px' },
                color: '#60A5DF'
              }}
            >
              {' '}
              Преміум
            </Typography>
            {' акаунтом!'}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: '14px', sm: '16px' },
              textAlign: 'left',
              mt: 1,
              display: randomPos === 1 ? 'none' : 'block'
            }}
          >
            Максимум можливостей без зайвих турбот
          </Typography>
          <LetsGoBtn
            colorScheme="blue"
            width="220px"
            margin="15px 0px 0px 0px"
            text="Спробувати Преміум"
            onClick={() => {
              navigate(`/ua/tariffs`);
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps)(Banner1);
